import React, { useEffect, useState } from 'react';
import {
  Button,
  Select,
  Skeleton,
  TextArea,
  TextField,
  Title
} from '@gerdau/hefesto';
import { DateField } from '@gerdau/hefesto-mais-web/DateField';
import { DateType } from '@gerdau/hefesto-mais-web/DateField/DateField.types';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import { Button as ButtonAntd } from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import FabricationContractsSelect from '../../../../components/FabricationContractsSelect';
import IsManagerFabricationContractInput from '../../../../components/IsManagerFabricationContractInput';
import { ERoutes } from '../../../../routes';
import { FabricationOrdersService } from '../../../../services/FabricationOrders';
import { ApplicationState } from '../../../../store';
import {
  loadCustomerContracts,
  updateConstructionRegistrationSettings
} from '../../../../store/ducks/contracts-and-constructions/actions';
import {
  ETowerOption,
  INITIAL_CONSTRUCTION_REGISTRATION
} from '../../../../store/ducks/contracts-and-constructions/types';
import {
  clearOrderVersionReview,
  loadContractByContractNumberV2,
  loadContractDetails,
  loadContractDetailsV2,
  loadContractsV2,
  loadOrderVersionReview
} from '../../../../store/ducks/fabrication-contracts/actions';
import {
  EFabricationContractsStatus,
  IFabricationContract,
  ILastOrderDetails
} from '../../../../store/ducks/fabrication-contracts/types';
import { IFabricationOrder } from '../../../../store/ducks/fabrication-orders/types';
import { IFabricationPurchaseOrderState } from '../../../../store/ducks/fabrication-purchase-order/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { ECustomerTypeView } from '../../../../store/ducks/user/types';
import { getTaggingInformationScreen } from '../../../../utils/Tagging';
import { cepInputValidator } from '../../../../utils/cepInputValidator';
import {
  textEllipsis,
  uppercaseOnlyFirstLetter
} from '../../../../utils/formatStrings';
import { getFabricationPurchaseStateFromFabricationOrder } from '../../../../utils/purchaseHelpers';
import { EConstructionsRoutes } from '../../../ContractsAndConstructions/contractsAndConstructions.routes';
import { EFabricationRoutes } from '../fabrication.routes';
import { isAllFieldsValidInConstructionIdentification } from '../fabricationOrderFieldsValidations';
import {
  ContainerFacelift,
  FabricationContainer,
  FabricationErrorBlock
} from '../styles';
import ContractWithoutConstructions from './ContractWithoutConstructions';

import MessageChooseContract from '../../../../components/MessageChooseContract';
import { EPurchaseRoutes } from '../../purchase.routes';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import FabricationTabs from '../FabricationTabs';
import ConstructionIdentificationLastOrdersTable from './ConstructionIdentificationLastOrdersTable';
import LoadingModal from '../../../../components/LoadingModal';
import {
  ButtonActionContainer,
  ButtonContainer,
  ConstructionContainer,
  ConstructionIdentificationContentBlock,
  ContructionIdentificationInputContainer,
  DeliveryNotesContainer,
  Message,
  OrderContainer,
  SearchContractButtonContainer,
  Subtitle
} from './styles';
import { updateFabricationPurchaseOrderSettings } from '../../../../store/ducks/fabrication-purchase-order/actions';
import { ChooseBetweenNewOrReviewOrderModal } from '../../../../components/ChooseBetweenNewOrReviewOrderModal';
import { EOrdersRoutes } from '../../../Orders/orders.routes';

interface IConstructionIdentificationProps {
  onBuyAgain(fabricationPurchaseState: IFabricationPurchaseOrderState): void;
  goToFabricationRoute(route: EFabricationRoutes, state?: object): void;
}

const ReviewOrders: React.FC<IConstructionIdentificationProps> = ({
  onBuyAgain,
  goToFabricationRoute
}) => {
  const [loadFabricationOrderState, setLoadFabricationOrderState] = useState<{
    loading: boolean;
    error: boolean;
    orderId?: number;
    orderNumber?: string;
  }>({ loading: false, error: false });

  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();
  const history = useHistory();
  const contractsState = useSelector(
    (appState: ApplicationState) => appState.fabricationContracts
  );

  const orderVersionReviewContract = useSelector(
    (state: ApplicationState) =>
      state.fabricationContracts.orderVersionReviewContract
  );

  const [isReviewRequested, setIsReviewRequested] = useState(
    orderVersionReviewContract !== undefined
  );
  // const [isRepeatOrder, setIsRepeatedOrder] = useState(false);

  const userState = useSelector((appState: ApplicationState) => appState.user);

  const fabricationPurchaseOrder = useSelector(
    (appState: ApplicationState) => appState.fabricationPurchaseOrder
  );

  const [detailingProjectState, setDetailingProjectState] = useState(
    fabricationPurchaseOrder.detailingProject
  );
  const [extraItensState, setExtraItensState] = useState(
    fabricationPurchaseOrder.extraItens
  );
  const [constructionIdentificationState, setConstructionIdentificationState] =
    useState(fabricationPurchaseOrder.constructionIdentification);

  const contractAndConstructionsContractsManager = useSelector(
    (state: ApplicationState) =>
      state.contractsAndConstructions.contractsManager
  );

  const { screenName = '' } = getTaggingInformationScreen(
    history.location.pathname,
    true
  );
  const getSelectedContract = (contractNumber?: string) => {
    return contractsState.contracts?.find(
      (contr) => !!contractNumber && contr.contractNumber === contractNumber
    );
  };

  const [isManagercontractNumber, setIsManagerContractNumber] = useState(
    constructionIdentificationState?.contractNumber
  );

  const [selectedContract, setSelectedContract] = useState(
    getSelectedContract(constructionIdentificationState?.contractNumber)
  );

  useEffect(() => {
    dispatch(
      sendTagging({ screenName, page: location.pathname, event: 'page_view' })
    );
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleUpdateStateField = (field: string, newValue: any) => {
    setConstructionIdentificationState({
      ...constructionIdentificationState,
      [field]: newValue
    });
  };

  const msgHelperText = 'Identificação do pedido para gestão interna da obra.';

  const onNextStepClick = () => {
    goToFabricationRoute(EFabricationRoutes.DETAILING_PROJECT, {
      came_from: 'REVIEW'
    });
    dispatch(
      sendTagging({
        screenName: 'LG:Comprar:CorteEDobra:IdentificacaoObra',
        event: 'click',
        itemName: 'button:avancarParaDetalhamento',
        itemDescription:
          'comprar_corteEDobra_identificacaoObra_avancarParaDetalhamento',
        filterInfo: `#cttObra:${selectedContract?.contractNumber}`,
        contratoObra: selectedContract?.contractNumber
      })
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onClickCancelButton = () => {
    dispatch(
      sendTagging({
        screenName: 'LG:Comprar:CorteEDobra:IdentificacaoObra',
        itemName: 'button:cancelar',
        event: 'click',
        filterInfo: `#cttObra:${selectedContract?.contractNumber}`,
        contratoObra: selectedContract?.contractNumber,
        itemDescription: `comprar_corteEDobra_identificacaoObra_cancelar`
      })
    );

    // we must know from where it came to return correctly
    setIsReviewRequested(false);
    dispatch(clearOrderVersionReview());
    switch (location.state?.from) {
      case 'ConstructionIdentification':
        history.push(
          `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`
        );
        break;
      case 'ReviewOrder':
        break;
      case 'FabricationOrderDetailsActionsButtons':
        history.push(`${ERoutes.ORDERS}/${EOrdersRoutes.FABRICATION_ORDERS}`, {
          back_to_view: {
            view: 'details',
            data: location.state.payload
          }
        });
        break;
      default:
        history.push(`${ERoutes.PURCHASE}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
    }
  };

  const handleChangeContractNumber = (selectedContractNumber: string) => {
    if (contractsState.contracts === undefined) {
      return;
    }

    const contract = getSelectedContract(
      selectedContractNumber
    ) as IFabricationContract;

    setConstructionIdentificationState({
      ...constructionIdentificationState,
      contractNumber: contract?.contractNumber,
      location: contract?.location,
      address: '',
      state: '',
      city: '',
      cep: '',
      towers: []
    });

    // onChangeContractNumber();
    !!contract.contractNumber &&
      dispatch(loadContractByContractNumberV2(contract.contractNumber));
    setSelectedContract(contract);
  };

  const handleLoadContractByContractNumber = () => {
    if (!isManagercontractNumber) {
      return;
    }

    setConstructionIdentificationState({
      ...constructionIdentificationState,
      contractNumber: isManagercontractNumber,
      location: '',
      address: '',
      state: '',
      city: '',
      cep: '',
      towers: []
    });

    // onChangeContractNumber();
    dispatch(loadContractByContractNumberV2(isManagercontractNumber));
  };

  const handleLoadContractDetails = (
    selectedContractNumber: string,
    customerShipTo?: string
  ) => {
    dispatch(loadContractDetails(selectedContractNumber, customerShipTo));
  };

  const handleLoadContractDetailsV2 = (selectedContractNumber: string) => {
    dispatch(loadContractDetailsV2(selectedContractNumber));
  };

  const initConstructionIdentificationAddress = () => {
    if (
      constructionIdentificationState?.contractNumber &&
      contractsState.contracts
    ) {
      const contract = getSelectedContract(
        constructionIdentificationState.contractNumber
      );

      if (
        contract &&
        contract.shipTo &&
        contract.shipTo.address &&
        (!constructionIdentificationState.cep ||
          constructionIdentificationState.cep !== contract.shipTo.zipCode)
      ) {
        setConstructionIdentificationState({
          ...constructionIdentificationState,
          location: contract.location,
          address: contract.shipTo.address,
          state: contract.shipTo.state || '',
          city: contract.shipTo.city || '',
          cep: contract.shipTo.zipCode || ''
        });
      } else if (
        !userState.isManager &&
        contract &&
        contract.status === EFabricationContractsStatus.OPEN &&
        !contract.shipTo?.address &&
        !contract.loadingDetails &&
        !contract.errorDetails
      ) {
        handleLoadContractDetailsV2(
          constructionIdentificationState.contractNumber
        );
      }
      setSelectedContract(contract);
    }
  };

  useEffect(() => {
    initConstructionIdentificationAddress();
  });

  const canShowToNextStep = () => {
    return isAllFieldsValidInConstructionIdentification(
      constructionIdentificationState,
      contractsState
    );
  };

  const isAnewContractSelected = (): boolean => {
    return (
      !!selectedContract &&
      selectedContract.status === EFabricationContractsStatus.NEW_CONTRACT
    );
  };

  const hasErrorOnLoadSelectedContractDetails = (): boolean => {
    return !!selectedContract && !!selectedContract.errorDetails;
  };

  const cleanConstructionIdentificationState = () => {
    setSelectedContract(undefined);
    setConstructionIdentificationState({
      ...constructionIdentificationState,
      contractNumber: undefined,
      location: '',
      address: '',
      state: '',
      city: '',
      cep: ''
    });
  };

  const goToConstructionRegistration = () => {
    if (selectedContract) {
      if (
        selectedContract.soldTo.code !==
          contractAndConstructionsContractsManager.selectedCustomerId ||
        contractAndConstructionsContractsManager.error
      ) {
        const customerType = userState.searchCustomerType;
        const customerId =
          customerType === ECustomerTypeView.EMITTER
            ? selectedContract.soldTo.code
            : selectedContract.shipTo.code;

        dispatch(loadCustomerContracts(customerId, customerType));
      }

      dispatch(
        updateConstructionRegistrationSettings({
          ...INITIAL_CONSTRUCTION_REGISTRATION,
          contractNumber: selectedContract.contractNumber
        })
      );

      history.push(
        `${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}${EConstructionsRoutes.CONSTRUCTION_REGISTRATION}`
      );
    }
  };

  const [showLoadingOrderModal, setShowLoadingOrderModal] = useState(false);

  const [
    showChooseBetweenNewOrReviewModal,
    setShowChooseBetweenNewOrReviewModal
  ] = useState<ILastOrderDetails>();

  const closeChooseBetweenNewOrReviewModal = () => {
    setShowChooseBetweenNewOrReviewModal(undefined);
  };

  const loadFabricationOrderFromId = async (
    orderId: number
  ): Promise<IFabricationOrder> => {
    const fabricationOrdersService = new FabricationOrdersService();
    return fabricationOrdersService.getFabricationOrderFromId(orderId);
  };

  const onBuyAgainClick = (order: ILastOrderDetails) => {
    setShowChooseBetweenNewOrReviewModal(order);
  };

  const commitBuyAgainClick = async (orderId: number) => {
    // setIsReviewRequested(true);
    const orderNumber =
      selectedContract?.lastOrderDetails?.find((lod) => lod.id === orderId)
        ?.orderNumber || '';

    try {
      setLoadFabricationOrderState({
        loading: true,
        error: false,
        orderId,
        orderNumber
      });
      setShowLoadingOrderModal(true);
      const fabricationOrder = await loadFabricationOrderFromId(orderId);
      const fabricationPurchaseState =
        getFabricationPurchaseStateFromFabricationOrder(fabricationOrder);

      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseState,
          constructionIdentification: {
            ...fabricationPurchaseState.constructionIdentification,
            orderNumber: ''
          }
        })
      );
      history.push(
        `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`
      );
    } catch (error) {
      setLoadFabricationOrderState({
        loading: false,
        error: true,
        orderId,
        orderNumber
      });
    }
  };

  const onRequestReview = async (contractNumber: string, orderId: number) => {
    setIsReviewRequested(true);

    const selectedOrder =
      contractsState?.selectedContract?.lastOrderDetails?.find(
        (order) => order.id === orderId
      );

    const gerdauOrderNumber = selectedOrder?.gerdauOrderNumber;

    if (contractNumber && gerdauOrderNumber !== undefined) {
      dispatch(loadOrderVersionReview(contractNumber, gerdauOrderNumber, true));

      const fabricationOrder = await loadFabricationOrderFromId(orderId);
      const fabricationPurchaseOrderState =
        getFabricationPurchaseStateFromFabricationOrder(fabricationOrder);
      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseOrderState,
          constructionIdentification: {
            ...fabricationPurchaseOrderState.constructionIdentification,
            orderNumber: ''
          }
        })
      );
    }
  };

  const getCustomerOrderText = (): string | undefined => {
    if (
      !isManagercontractNumber ||
      isManagercontractNumber.length < 6 ||
      !contractsState.contracts ||
      contractsState.contracts.length === 0
    ) {
      return undefined;
    } else {
      const contract = contractsState.contracts?.find(
        (cont) => cont.contractNumber === isManagercontractNumber
      );
      return (
        contract &&
        (`${contract.contractNumber} - ${textEllipsis(
          contract.customerOrder,
          24
        )}` ||
          undefined)
      );
    }
  };

  const canShowTowersSelect = (): boolean => {
    return (
      !!selectedContract &&
      selectedContract.logistic?.towerOption !== null &&
      selectedContract.logistic?.towerOption !== ETowerOption.UNIQUE &&
      !!selectedContract.logistic?.towers &&
      selectedContract.logistic?.towers.length > 0
    );
  };

  const orderNumberAlreadyExistsForSelectedContract =
    (Array.isArray(selectedContract?.allOrderNumbers) &&
      selectedContract?.allOrderNumbers.some(
        (oldOrder) =>
          oldOrder.toUpperCase() ===
          constructionIdentificationState.orderNumber.toUpperCase()
      )) ||
    false;

  const onChangeOrderNumber = (value: string) => {
    const regex = /[^a-zA-Z0-9--]+$/;
    const formattedValue = value.replace(regex, '');
    handleUpdateStateField('orderNumber', formattedValue.trim());
  };

  const showChooseWorkContract = () => {
    return (
      <MessageChooseContract>
        <Message>
          Escolha o contrato de obra <br /> para iniciar seu novo pedido.
        </Message>
      </MessageChooseContract>
    );
  };

  const getBreadcrumbs = () => {
    return [
      { name: 'Comprar', url: ERoutes.PURCHASE },
      {
        name: 'Revisar pedido por histórico',
        url: `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION_REVIEW_ORDER}`
      }
    ];
  };

  const loadContractsIfNeed = () => {
    if (
      !userState.isManager &&
      contractsState.contracts === undefined &&
      !contractsState.loading &&
      !contractsState.error
    ) {
      dispatch(loadContractsV2());
    }
  };

  useEffect(() => {
    loadContractsIfNeed();
  }, []);

  const handleNewOrderRequest = () => {
    history.push({
      pathname: `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`
    });
  };

  const updateFabricationOrderState = () => {
    if (
      !pathname.includes(EFabricationRoutes.SUCCESS) &&
      !pathname.includes(EFabricationRoutes.CHECKOUT)
    ) {
      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseOrder,
          constructionIdentification: {
            ...constructionIdentificationState,
            gerdauRevisionNumber:
              orderVersionReviewContract?.newOrderVersion?.revision,
            gerdauOrderNumber:
              orderVersionReviewContract?.newOrderVersion?.orderNumber
          },
          detailingProject: detailingProjectState,
          extraItens: extraItensState
        })
      );
    }
  };

  interface ConstructionIdentificationTableDataSource {
    key: number;
    orderNumber: string;
    sendDate: string;
    orderId: number;
    enableRevision?: boolean;
    formattedOrderCode?: string;
  }
  const dataResult: ConstructionIdentificationTableDataSource[] =
    selectedContract?.lastOrderDetails?.map((order, idx) => {
      return {
        key: idx,
        codGerdau: order.contractNumber,
        orderNumber: order.orderNumber,
        sendDate: order.sendDate,
        orderId: order.id,
        enableRevision: order.enableRevision,
        formattedOrderCode: order.formattedOrderCode
      };
    }) ?? [];
  const revisionEnabled = (orderId: number) => {
    return {
      enableRevision: !!dataResult.find(
        (data) => Number(data.orderId) === orderId
      )?.enableRevision,
      tooltipDisabledRevision:
        'Solicite revisões e alterações dos seus pedidos com pelo menos 7 dias úteis antes da data de entrega para avaliação e confirmação da equipe de programação. Para estaca armada este prazo é de pelo menos 10 dias úteis.'
    };
  };

  useEffect(() => {
    if (
      fabricationPurchaseOrder.constructionIdentification.comingFromBuyAgain
    ) {
      if (
        fabricationPurchaseOrder.constructionIdentification !==
        constructionIdentificationState
      ) {
        setConstructionIdentificationState(
          fabricationPurchaseOrder.constructionIdentification
        );
      }
      if (fabricationPurchaseOrder.detailingProject !== detailingProjectState) {
        setDetailingProjectState(fabricationPurchaseOrder.detailingProject);
      }
      if (fabricationPurchaseOrder.extraItens !== extraItensState) {
        setExtraItensState(fabricationPurchaseOrder.extraItens);
      }
    }
  }, [
    fabricationPurchaseOrder.constructionIdentification,
    fabricationPurchaseOrder.detailingProject
  ]);

  // dispara ação de atualizar estado quando trocar de página
  useEffect(() => {
    const unlisten = history.listen(() => {
      updateFabricationOrderState();
    });

    return () => {
      unlisten();
    };
  });

  useEffect(() => {
    if (
      selectedContract?.contractNumber &&
      selectedContract?.lastOrderNumber &&
      isReviewRequested
    ) {
      const lastGerdauOrderNumber = selectedContract?.lastOrderDetails?.find(
        (order) => order.orderNumber === selectedContract?.lastOrderNumber
      )?.gerdauOrderNumber;
      dispatch(
        loadOrderVersionReview(
          selectedContract?.contractNumber,
          Number(lastGerdauOrderNumber),
          true
        )
      );
    }
  }, [selectedContract]);

  const reviewFabricationContract = useSelector(
    (state: ApplicationState) =>
      state.fabricationContracts.orderVersionReviewContract
  );

  useEffect(() => {
    if (reviewFabricationContract) {
      setIsReviewRequested(true);
    }
  }, [reviewFabricationContract]);

  return (
    <>
      {isAnewContractSelected() && (
        <ContractWithoutConstructions
          cleanConstructionIdentificationState={
            cleanConstructionIdentificationState
          }
          goToConstructionRegistration={goToConstructionRegistration}
        />
      )}
      <ContainerFacelift
        isEmitter={userState.searchCustomerType === ECustomerTypeView.EMITTER}
      >
        <Breadcrumbs
          breadcrumbItems={getBreadcrumbs()}
          onClick={(e) => {
            history.push(e);
          }}
        />
        <div>
          <Title level={1}>Revisar pedido por histórico</Title>
          <Subtitle>
            Revise seus pedidos de aços cortados e dobrados a partir do seu
            histórico de compra.
          </Subtitle>
        </div>
        <FabricationTabs />
      </ContainerFacelift>
      <FabricationContainer isFacelift={true}>
        <ConstructionContainer>
          <Title level={2}>Identificação da obra</Title>

          <span className="subtitle">
            Selecione um contrato para abrir as informações da sua obra.
          </span>

          <ConstructionIdentificationContentBlock className="last-order">
            {userState.isManager && (
              <ContructionIdentificationInputContainer className="facelift">
                <IsManagerFabricationContractInput
                  title="Contrato"
                  loading={contractsState.loading}
                  contractError={contractsState.contractError || false}
                  contractNumber={isManagercontractNumber || ''}
                  setContractNumber={setIsManagerContractNumber}
                  customerOrder={getCustomerOrderText()}
                />
              </ContructionIdentificationInputContainer>
            )}

            {!userState.isManager && (
              <ContructionIdentificationInputContainer className="facelift">
                <FabricationContractsSelect
                  contractNumber={
                    constructionIdentificationState?.contractNumber
                  }
                  onChange={(value: string) =>
                    handleChangeContractNumber(value)
                  }
                  contracts={
                    (contractsState.contracts &&
                      contractsState.contracts.filter(
                        (contract) =>
                          contract.status ===
                            EFabricationContractsStatus.OPEN ||
                          contract.status ===
                            EFabricationContractsStatus.NEW_CONTRACT
                      )) ||
                    []
                  }
                  loading={contractsState.loading}
                  readOnly={isReviewRequested}
                />
              </ContructionIdentificationInputContainer>
            )}

            <ContructionIdentificationInputContainer className="last-order-facelift">
              <OrderContainer>
                <TextField
                  name="lastOrderNumberInput"
                  label="Código do último pedido"
                  value={
                    (selectedContract &&
                      contractsState?.selectedContract?.lastOrderNumber) ||
                    ' - '
                  }
                  disabled={contractsState.loading}
                  readOnly
                ></TextField>
              </OrderContainer>
            </ContructionIdentificationInputContainer>

            <ButtonActionContainer>
              <Button
                name="lastOrdersButton"
                variant="secondary"
                disabled={
                  loadFabricationOrderState.loading ||
                  !contractsState.selectedContract?.lastOrderNumber ||
                  !contractsState.selectedContract?.lastOrderDetails
                }
                onClick={handleNewOrderRequest}
              >
                Solicitar novo pedido
              </Button>
            </ButtonActionContainer>
          </ConstructionIdentificationContentBlock>

          {userState.isManager && (
            <SearchContractButtonContainer>
              <Button
                variant="primary"
                name="searchContractButton"
                onClick={handleLoadContractByContractNumber}
                loading={contractsState.loading}
                disabled={
                  contractsState.loading ||
                  !isManagercontractNumber ||
                  isManagercontractNumber.length < 4
                }
              >
                Buscar
              </Button>
            </SearchContractButtonContainer>
          )}

          {constructionIdentificationState.contractNumber !== undefined &&
            hasErrorOnLoadSelectedContractDetails() && (
              <FabricationErrorBlock>
                <span>
                  Falha ao carregar os detalhes do contrato{' '}
                  {constructionIdentificationState.contractNumber}.
                </span>
                <ButtonAntd
                  type="primary"
                  onClick={() =>
                    constructionIdentificationState.contractNumber &&
                    handleLoadContractDetails(
                      constructionIdentificationState.contractNumber
                    )
                  }
                >
                  Tentar novamente
                </ButtonAntd>
              </FabricationErrorBlock>
            )}
        </ConstructionContainer>

        {selectedContract && isReviewRequested ? (
          <>
            <ConstructionContainer>
              <Title level={2}>Identificação do pedido</Title>
              <ConstructionIdentificationContentBlock>
                <ContructionIdentificationInputContainer
                  className={
                    orderNumberAlreadyExistsForSelectedContract
                      ? 'has-error'
                      : undefined
                  }
                >
                  <TextField
                    data-testid="order-number-test-id"
                    label="Número do pedido"
                    name="input-numero-pedido"
                    value={
                      orderVersionReviewContract?.newOrderVersion
                        ?.formattedOrderCode
                    }
                    readOnly
                    supportMessage="Este pedido é uma revisão."
                  />
                </ContructionIdentificationInputContainer>

                <ContructionIdentificationInputContainer
                  className={
                    orderNumberAlreadyExistsForSelectedContract
                      ? 'has-error'
                      : undefined
                  }
                >
                  <TextField
                    data-testid="order-number-test-id"
                    label="Identificação do pedido"
                    name="input-codigo-pedido"
                    placeholder="Crie um código para o pedido"
                    value={constructionIdentificationState.orderNumber}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      onChangeOrderNumber(e.target.value);
                    }}
                    supportMessage={
                      !showLoadingOrderModal &&
                      orderNumberAlreadyExistsForSelectedContract
                        ? 'Já existe um pedido com o código digitado.'
                        : constructionIdentificationState.orderNumber &&
                          constructionIdentificationState.orderNumber.trim()
                            .length < 3
                        ? 'Deve ter no mínimo 3 caracteres'
                        : constructionIdentificationState.orderNumber &&
                          constructionIdentificationState.orderNumber.trim()
                            .length > 20
                        ? 'Use de 3 a 20 letras e/ou números'
                        : ''
                    }
                    variant={
                      !showLoadingOrderModal &&
                      orderNumberAlreadyExistsForSelectedContract
                        ? 'danger'
                        : undefined ||
                          (constructionIdentificationState.orderNumber &&
                            constructionIdentificationState.orderNumber.trim()
                              .length < 3)
                        ? 'danger'
                        : undefined
                    }
                    maxLength={24}
                    helperText={msgHelperText}
                  />
                </ContructionIdentificationInputContainer>

                <ContructionIdentificationInputContainer>
                  <DateField
                    name="dateField"
                    label="Data desejada:"
                    helperText="A estimativa de entrega do pedido está sujeita a alterações."
                    selected={
                      constructionIdentificationState.desiredDate
                        ? moment(
                            constructionIdentificationState.desiredDate,
                            'YYYY-MM-DD'
                          ).toDate()
                        : undefined
                    }
                    data-testid="dateFieldIdentificacaoPedido"
                    onChange={(value: DateType) => {
                      if (value) {
                        handleUpdateStateField('desiredDate', value);
                      }
                    }}
                    minDate={moment().add(1, 'day').toDate()}
                  />
                </ContructionIdentificationInputContainer>
              </ConstructionIdentificationContentBlock>
            </ConstructionContainer>

            <ConstructionContainer>
              <Title level={2}>Endereço da obra</Title>

              <div className="wrapperWorkDetails">
                <div className="workDetails">
                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer>
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <TextField
                          label={'CEP da obra'}
                          name={'cep'}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const cep = cepInputValidator(e);
                            handleUpdateStateField('cep', cep);
                          }}
                          value={constructionIdentificationState.cep}
                          readOnly
                        />
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>

                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer className="double-width">
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <TextField
                          value={uppercaseOnlyFirstLetter(
                            constructionIdentificationState.address
                          )}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleUpdateStateField('address', e.target.value)
                          }
                          readOnly
                          label={'Logradouro'}
                          name={'logradouro'}
                        />
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>
                </div>

                <div className="workDetails">
                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer>
                      {canShowTowersSelect() ? (
                        <Select
                          value={constructionIdentificationState.towers}
                          onSelect={(value) =>
                            handleUpdateStateField('towers', value as string[])
                          }
                          disabled={!selectedContract}
                          options={
                            selectedContract?.logistic?.towers.map((tower) => {
                              return {
                                label: tower,
                                value: tower
                              };
                            }) as TSelectOptionProps[]
                          }
                          isMultipleSelect={true}
                          label={'Selecione a torre'}
                          name={'towers'}
                          helperText={
                            'Torre ou bloco se refere ao setor do edifício para o qual o contrato se refere.'
                          }
                          supportMessage="Use até 24 letras e/ou números"
                        ></Select>
                      ) : (
                        <TextField
                          value={
                            constructionIdentificationState.towers &&
                            constructionIdentificationState.towers.length > 0
                              ? constructionIdentificationState.towers[0]
                              : ''
                          }
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleUpdateStateField('towers', [e.target.value]);
                          }}
                          label={'Torre ou Bloco'}
                          name={'towerOrBlock'}
                          helperText={
                            'Torre ou bloco se refere ao setor do edifício para o qual o contrato se refere.'
                          }
                          supportMessage="Use até 24 letras e/ou números"
                        />
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>

                  <ConstructionIdentificationContentBlock>
                    <ContructionIdentificationInputContainer columns={2}>
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <Select
                          value={constructionIdentificationState.state}
                          onSelect={(value) =>
                            handleUpdateStateField('state', value as string)
                          }
                          readOnly
                          label={'UF'}
                          name={'UF'}
                          options={[
                            {
                              label: constructionIdentificationState.state,
                              value: constructionIdentificationState.state
                            }
                          ]}
                        ></Select>
                      )}
                    </ContructionIdentificationInputContainer>

                    <ContructionIdentificationInputContainer full>
                      {contractsState.loading ? (
                        <Skeleton type="input" />
                      ) : (
                        <Select
                          value={uppercaseOnlyFirstLetter(
                            constructionIdentificationState.city
                          )}
                          onSelect={(value) =>
                            handleUpdateStateField('city', value as string)
                          }
                          readOnly
                          label={'Selecione a cidade'}
                          name={'city'}
                          options={[
                            {
                              label: uppercaseOnlyFirstLetter(
                                constructionIdentificationState.city
                              ),
                              value: uppercaseOnlyFirstLetter(
                                constructionIdentificationState.city
                              )
                            }
                          ]}
                        ></Select>
                      )}
                    </ContructionIdentificationInputContainer>
                  </ConstructionIdentificationContentBlock>
                </div>
              </div>
            </ConstructionContainer>

            <ConstructionContainer>
              <DeliveryNotesContainer>
                <Title level={2}>Observações de entrega</Title>

                <TextArea
                  name="deliveryNotesTextArea"
                  label="Observações"
                  value={constructionIdentificationState.observation}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                    handleUpdateStateField('observation', e.target.value)
                  }
                  cols={200}
                  resizable={false}
                  maxLength={500}
                  supportMessage={
                    constructionIdentificationState.observation.length == 500
                      ? 'Deve ter no máximo 500 caracteres'
                      : 'Use até 500 letras e/ou números'
                  }
                />
              </DeliveryNotesContainer>
            </ConstructionContainer>
          </>
        ) : (
          <>
            {selectedContract ? (
              <ConstructionContainer withoutBg>
                <ConstructionIdentificationLastOrdersTable
                  selectedContract={contractsState.selectedContract}
                  onBuyAgainClick={onBuyAgainClick}
                  onRequestReview={onRequestReview}
                  revisionEnabled={revisionEnabled}
                />
              </ConstructionContainer>
            ) : (
              showChooseWorkContract()
            )}
          </>
        )}

        <LoadingModal
          enabled={contractsState.loading}
          title="Aguarde alguns instantes"
          message="Carregando os dados..."
        />

        <ConstructionContainer buttonContainer>
          <ButtonContainer>
            <Button
              type="button"
              variant="primary"
              labelPosition="center"
              name="cancelAndReturnButton"
              onClick={onClickCancelButton}
            >
              Voltar
            </Button>
            {selectedContract && isReviewRequested && (
              <Button
                name="goToDetailButton"
                onClick={onNextStepClick}
                variant="primary"
                disabled={!canShowToNextStep()}
              >
                Avançar para o detalhamento
              </Button>
            )}
          </ButtonContainer>
        </ConstructionContainer>
      </FabricationContainer>
      {showChooseBetweenNewOrReviewModal && (
        <ChooseBetweenNewOrReviewOrderModal
          onCloseModal={closeChooseBetweenNewOrReviewModal}
          order={showChooseBetweenNewOrReviewModal}
          onChooseCreate={() =>
            commitBuyAgainClick(showChooseBetweenNewOrReviewModal?.id)
          }
          revisionEnabled={revisionEnabled}
          from={'ReviewOrder'}
        />
      )}
    </>
  );
};

export default ReviewOrders;
